// extracted by mini-css-extract-plugin
export var container = "_20-0";
export var disabled = "_20-4";
export var fullWidth = "_20-3";
export var lined = "_20-1";
export var selected = "_20-5";
export var tab = "_20-2";